var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"button-new flex items-center justify-center text-slate-900 dark:text-white text-sm font-medium cursor-pointer",on:{"click":_vm.handleClick}},[(_vm.icon)?_c('fluent-icon',{staticClass:"mr-2",attrs:{"size":20,"icon":_vm.icon}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }